<template>
  <div class="index">
    <div class="header_top">
      <div class="header_top">
        <div class="index_heder">
          <div class="logo_img">
            <img src="../../assets/info/logo1.png" class="logo1" alt="" />
            <div class="index_title">金骊保电子保函平台</div>
          </div>
          <div class="tab_list">
            <a-tabs default-active-key="1" @change="callback">
              <a-tab-pane key="1" tab="首页"> </a-tab-pane>
              <a-tab-pane key="2" tab="保函申请"> </a-tab-pane>
              <a-tab-pane key="4" tab="保函验真"> </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
    </div>
    <a-carousel arrows>
      <div class="index_home_img">
        
        <div class="img_bg">
          <a-carousel :autoplay="true" :easing="linear">
            <!-- <img class="img" src="../../assets/info/banner1.jpg" alt="">
            <img class="img" src="../../assets/info/banner2.jpg" alt="">
            <img class="img" src="../../assets/info/banner3.jpg" alt=""> -->
            <div :style="{backgroundImage: 'url(' + require('@/assets/info/banner1.png') + ')'}" class="img_bg_back">
              <img class="img" src="../../assets/info/banner1.png" alt="" style="visibility: hidden;">
              <div class="img_bg_i" :style="{backgroundImage: 'url(' + require('@/assets/info/banner1_i.png') + ')'}"></div>
            </div>
            <div :style="{backgroundImage: 'url(' + require('@/assets/info/banner2.png') + ')'}" class="img_bg_back" @click="$router.push('./guaranteeTruth')">
              <img class="img" src="../../assets/info/banner2.png" alt="" style="visibility: hidden;">
              <div class="img_bg_i2" :style="{backgroundImage: 'url(' + require('@/assets/info/banner2_i.png') + ')'}"></div>
            </div>
            <div :style="{backgroundImage: 'url(' + require('@/assets/info/banner3.png') + ')'}" class="img_bg_back" @click="$router.push('./orderCenter')">
              <img class="img" src="../../assets/info/banner3.png" alt="" style="visibility: hidden;">
              <div class="img_bg_i3" :style="{backgroundImage: 'url(' + require('@/assets/info/banner3_i.png') + ')'}"></div>
              <div class="img_bg_i3_right" :style="{backgroundImage: 'url(' + require('@/assets/info/img_bg_i3_right.png') + ')'}"></div>
            </div>
            
          </a-carousel>
          <!-- <div class="bannerCon">
            <div class="title">金骊保</div>
            <div class="con">集成全类型保函支持各类机构，解放繁琐流程，自动出函让您的保函业务更轻松更智能。</div>
            <div class="btn">免费试用</div>
          </div> -->
        </div>
      </div>
    </a-carousel>
    <div class="product">
      <div class="title">产品服务</div>
      <div class="sTitle"><img src="../../assets/info/titleImg.png" alt="" />全流程线上一站式办理7*24小时 服务不打烊</div>
      <div class="content">
        <div class="con">
          <div class="t">履约保函</div>
          <div class="c">是担保人应被保证人申请向工程承包项日中的业主或商品买卖中的买方出具的，保证被保证人严格按照合同约定全面和实际地履行其合同责任和义务的一种保函。</div>
          <div class="btn" @click="goTo(2)">立即购买<img src="../../assets/info/jt.png" alt="" /></div>
          <img class="bgIcon" src="../../assets/info/iconImg1.png" alt="">
        </div>
        <div class="con">
          <div class="t">预付款保函</div>
          <div class="c">是指保证人为承包方向发包方提供的，在发包方预先支付一定数额款项以供承包方周转使用后，保证承包方在收到预付款后按施工合同约定专款专用的一种保函。</div>
          <div class="btn" @click="goTo(4)">立即购买<img src="../../assets/info/jt.png" alt="" /></div>
          <img class="bgIcon" src="../../assets/info/iconImg2.png" alt="">
        </div>
        <div class="con">
          <div class="t">投标保函</div>
          <div class="c">是在通过招标方式成交的工程建造和物资采购等项目中，投标方为响应招标方的要求向保证人申请出具的，保证投标方履行招标文件的一种保函。</div>
          <div class="btn" @click="goTo(1)">立即购买<img src="../../assets/info/jt.png" alt="" /></div>
          <img class="bgIcon" src="../../assets/info/iconImg3.png" alt="">
        </div>
        <div class="con">
          <div class="t">农民工工资保函</div>
          <div class="c">是指保证人为承包方向发包方提供的，在发包方预先支付一定数额款项以供承包方周转使用后，保证承包方在收到预付款后按施工合同约定专款专用的一种保函。</div>
          <div class="btn" @click="goTo(3)">立即购买<img src="../../assets/info/jt.png" alt="" /></div>
          <img class="bgIcon" src="../../assets/info/iconImg4.png" alt="">
        </div>
      </div>
      
    </div>
    <div class="partner">
      <div class="title">合作银行</div>
      <div class="list list1">
        <div v-for="i in imgList1" :key="i" class="img_bank">
          <img loading="lazy" :src="i" alt="" />
        </div>
      </div>
      <div class="list list2">
        <div v-for="i in imgList2" :key="i" class="img_bank">
          <img loading="lazy" :src="i" alt="" />
        </div>
      </div>
    </div>
    <Footer></Footer>
    <a-modal
      class="rules"
      v-model="tipShow"
      title="温馨提示"
      centered
      :mask-closable="false"
    >
      <p class="tip">敬请期待！</p>
      <template v-slot:footer>
        <a-button class="btn_w btn" @click="tipShow = false" type="primary">
          关闭
        </a-button>
      </template>
    </a-modal>
  </div>
 
</template>
<script>
import Footer from "./footer.vue";
import Tab from "../../components/Tab/index.vue";
import Banner from "./banner.vue";
import { getBanner } from "../../api/index";
export default {
  components: { Footer, Tab, Banner },
  data() {
    return {
      isOpen: false,
      tipShow: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      RouterArray: [
        {
          path: "/",
          name: "首页",
          id: 1,
        },
        {
          path: "/login",
          name: "用户登录",
          id: 2,
        },
        {
          path: "/property",
          name: "保函申请",
          id: 3,
        },
        {
          path: "/guaranteeTruth",
          name: "保函验真",
          id: 4,
        },
      ],
      form: {
        insureType: "",
        insureLimit: "",
        insureAmount: "",
        result: "",
      },
      imgList1: [
        require("../../assets/info/b1.png"),
        require("../../assets/info/b2.png"),
        require("../../assets/info/b3.png"),
        require("../../assets/info/b4.png")
      ],
      imgList2: [
        require("../../assets/info/b5.png"),
        require("../../assets/info/b6.png"),
        require("../../assets/info/b7.png")
      ],
    };
  },
  mounted() {
    //this.getBanner();
  },
  methods: {
    callback(e) {
      let url = this.RouterArray.filter((item) => {
        return item.id == e;
      })[0].path;
      this.$router.push({ path: url });
    },
    goTo(value) {
      if(value !== 1) {
        if (localStorage.getItem("token")) {
          this.$router.push({ path: "/enterForm", query: { type: 'add', productV: value } });
        } else {
          this.$router.push({ path: "/login" });
        }
      } else {
        this.tipShow = true
      }
    },
    getBanner() {
      getBanner().then((res) => {
        this.bannerArr = res.data.filter(
          (item) => item.type == 0 && item.state == 1
        );
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  background: #fff;
  .navbar {
    width: 1180px;
    height: 130px;
    // background: #0335b5;
    position: absolute;
    top: 470px;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    justify-content: space-between;
    .nav_box {
      width: 380px;
      height: 130px;
      background: linear-gradient(
        180deg,
        #eef6ff 0%,
        #e5eef9 0%,
        #ffffff 44%,
        #ffffff 100%
      );
      box-shadow: 0px 4px 24px 6px rgba(112, 144, 176, 0.1);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      padding: 20px 40px;

      .right_text {
        margin-left: 20px;
        padding-top: 12px;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        .num {
          font-size: 32px;
          font-family: DIN Medium-Regular, DIN Medium;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
  .index_home_img {
    width: 100%;
    height: 600px;
    background: white;
    .img_bg {
      width: 100%;
      height: 600px;
      position: relative;
      background: url('../../assets/info/banner.png') no-repeat;
      .img {
        width: 100%;
        height: 100%;
      }
      .bannerCon {
        width: 1200px;
        margin: 0 auto;
        padding-left: 70px;
        .title {
          padding-top: 119px;
          font-weight: 500;
          font-size: 36px;
          color: #333333;
        }
        .con {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 25px;
          width: 400px;
          margin-top: 10px
        }
        .btn {
          width: 80px;
          height: 39px;
          background: #0E52D4;
          border-radius: 6px 6px 6px 6px;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          line-height: 39px;
          cursor: pointer;
          margin-top: 35px;
        }
      }
    }
    .header_top{
      position: fixed;
      top: 0;
      left: 0;
      height: 82px;
      z-index: 100;
      background: #fff;
      width: 100%;
      box-shadow: 0 1px 4px rgba(0,21,41,.08)
    }
    
  }
  .product {
    width: 1200px;
    margin: 20px auto 0;
    .title {
      font-weight: 500;
      font-size: 28px;
      color: #333333;
      text-align: center;
    }
    .sTitle {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      padding-top: 20px;
      display: flex;
      img {
        width: 20px;
        height: 20px;
        margin-right: 7px;
        display: block;
        margin-top: 5px;
      }
    }
    .content {
      display: flex;
      margin-top: 20px;
      .con {
        width: 285px;
        height: 340px;
        background: linear-gradient( 136deg, #F0F4FD 0%, #FAFCFE 50%, #F0F4FD 100%);
        border-radius: 6px 6px 6px 6px;
        padding: 0 22px;
        position: relative;
        margin-right: 20px;
        .t {
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          padding-top: 20px;
        }
        .c {
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
          margin-top: 12px;
          height: 120px;
        }
        .btn {
          width: 88px;
          height: 32px;
          background: linear-gradient( 350deg, #3A90ED 0%, #8EC2FD 100%);
          border-radius: 6px 6px 6px 6px;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 32px;
          text-align: center;
          margin-top: 16px;
          cursor: pointer;
          img {
            width: 12px;
            height: 12px;
            margin-left: 5px;
            position: relative;
            top: -1px;
          }
        }
        .bgIcon {
          width: 110px;
          height: 110px;
          display: block;
          position: absolute;
          right: 10px;
          bottom: 0px;
        }
      }
    }
  }
  .partner {
    width: 1200px;
    margin: 30px auto 0;
    text-align: center;
    padding-bottom: 20px;
    .title {
      font-weight: 500;
      font-size: 28px;
      color: #333;
    }
    .list {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      .img_bank {
        margin: 0 46px 20px 0;
        img {
          width: 208px;
          height: 90px;
        }
      }
      .img_bank:nth-child(5n) {
        margin-right: 0;
      }
    }
    .list1 {
        margin-left: 118px;
    }
    .list2 {
        margin-left: 246px;
    }
  }
}
</style>
<style scoped>
/* For demo */
.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}
/*
::v-deep .ant-tabs-bar {
  border-bottom: none !important;
}
::v-deep .ant-tabs-nav .ant-tabs-tab {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #666666;;
}
::v-deep .ant-tabs-ink-bar {
  background: #ffffff;
} */
::v-deep .ant-tabs-bar {
  border-bottom: none !important;
}
::v-deep .ant-tabs-tab {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
::v-deep .ant-tabs-nav .ant-tabs-tab-active {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: bold;
  color: #0E52D4;
}
::v-deep .ant-tabs-ink-bar {
  background: #0E52D4;
}
::v-deep .ant-tabs-nav .ant-tabs-tab:hover {
  color: #0E52D4;
  font-weight: bold;
}
::v-deep .ant-tabs {
  height: 52px;
}
.tip {
  font-size: 20px;
}
.header_top{
  position: fixed;
  left: 0;
  top: 0;
  height: 62px;
  width: 100%;
  background: #fff;
  z-index: 100;
  -webkit-box-shadow: 0 1px 4px rgba(0,21,41,.08);
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
.header_top .index_heder {
    width: 1200px;
    margin: auto;
    padding: 5px 0;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    .logo_img {
      margin-right: 226px;
      margin-top: 8px;
      line-height: 36px;
      width: 300px;
      img {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }
    }
}
.index_title{
  float: left;
}
.logo1{
  float: left;
}
.img_bg_back{
  background-repeat: no-repeat; /* 防止背景图片重复 */
  background-position: center center; /* 水平垂直居中 */
  background-size: 100% 100%;
  height: 600px;
  min-width: 1024px;
  position: relative;
}
.img_bg_i{
  width: 470px;
  height: 316px;
  left: 200px;
  top: 110px;
  background-size:100% 100%;
  position: absolute;
}
.img_bg_i2{
  width: 724px;
  height: 266px;
  left: 200px;
  top: 110px;
  background-size:100% 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.img_bg_i3{
  width: 760px;
  height: 266px;
  background-size:100% 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.img_bg_i3_right{
  width: 460px;
  height: 460px;
  background-size:100% 100%;
  position: absolute;
  right: 40px;
  bottom: -50px;
}
</style>
